var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlocks(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 421,
    viewBox: "0 0 1440 421",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Blocks"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Block Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "L3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Block01",
    y: 161,
    width: 400,
    height: 80,
    rx: 8,
    fill: "#E4E7EC"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Block03",
    x: 989,
    y: 161,
    width: 451,
    height: 80,
    rx: 8,
    fill: "#E4E7EC"
  })), /*#__PURE__*/React.createElement("g", {
    id: "L2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Block04",
    y: 251,
    width: 449,
    height: 80,
    rx: 8,
    fill: "#E4E7EC"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Block06",
    x: 745,
    y: 251,
    width: 695,
    height: 80,
    rx: 8,
    fill: "#E4E7EC"
  })), /*#__PURE__*/React.createElement("g", {
    id: "L1"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Block07",
    y: 341,
    width: 501,
    height: 80,
    rx: 8,
    fill: "#E4E7EC"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Block08",
    x: 511,
    y: 341,
    width: 559,
    height: 80,
    rx: 8,
    fill: "#E4E7EC"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Block09",
    x: 1080,
    y: 341,
    width: 360,
    height: 80,
    rx: 8,
    fill: "#E4E7EC"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Building"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M387.728 132.364V141.615H382.596C381.501 141.615 380.451 141.181 379.677 140.407C378.903 139.633 378.468 138.583 378.468 137.489V132.364H387.728Z",
    fill: "#06937F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M382.595 143.474H387.727V152.727H378.479V147.601C378.479 146.508 378.912 145.461 379.684 144.687C380.455 143.914 381.502 143.477 382.595 143.474Z",
    fill: "#06937F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M376.62 147.601V152.727H367.364V143.474H372.496C373.59 143.475 374.639 143.911 375.412 144.684C376.186 145.458 376.62 146.507 376.62 147.601Z",
    fill: "#06937F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M372.496 141.615H367.364V132.364H376.62V137.493C376.619 138.586 376.184 139.634 375.411 140.407C374.638 141.179 373.59 141.614 372.496 141.615Z",
    fill: "#06937F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M378.738 143.693C378.269 144.163 377.869 144.697 377.551 145.28C376.911 144.109 375.949 143.146 374.777 142.506C375.948 141.866 376.911 140.904 377.551 139.735C378.191 140.905 379.153 141.867 380.324 142.506C379.741 142.824 379.207 143.224 378.738 143.693Z",
    fill: "#06937F"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M455.54 22.4364H365.758V3.34546C365.758 2.62214 365.471 1.92845 364.959 1.41699C364.448 0.905524 363.754 0.618187 363.031 0.618187H337.122C336.398 0.618187 335.705 0.905524 335.193 1.41699C334.682 1.92845 334.394 2.62214 334.394 3.34546V22.4364H330.303V13.2455C330.303 12.5221 330.016 11.8284 329.505 11.317C328.993 10.8055 328.299 10.5182 327.576 10.5182H310.776C310.053 10.5182 309.359 10.8055 308.848 11.317C308.336 11.8284 308.049 12.5221 308.049 13.2455V22.4364H302.813C302.089 22.4364 301.395 22.7237 300.884 23.2352C300.373 23.7466 300.085 24.4403 300.085 25.1636V43.1091C300.085 43.8324 300.373 44.5261 300.884 45.0376C301.395 45.549 302.089 45.8364 302.813 45.8364H334.394V153.345H302.813C302.089 153.345 301.395 153.633 300.884 154.144C300.373 154.656 300.085 155.349 300.085 156.073C300.085 156.796 300.373 157.49 300.884 158.001C301.395 158.513 302.089 158.8 302.813 158.8H397.612C398.336 158.8 399.03 158.513 399.541 158.001C400.052 157.49 400.34 156.796 400.34 156.073C400.34 155.349 400.052 154.656 399.541 154.144C399.03 153.633 398.336 153.345 397.612 153.345H365.758V45.8364H441.303V158.088C441.303 158.812 441.591 159.505 442.102 160.017C442.614 160.528 443.307 160.816 444.031 160.816C444.849 160.821 445.648 161.069 446.326 161.528C447.004 161.986 447.531 162.636 447.841 163.394C448.151 164.151 448.229 164.984 448.066 165.787C447.903 166.589 447.506 167.325 446.925 167.902C446.344 168.479 445.606 168.871 444.802 169.029C443.999 169.187 443.167 169.103 442.411 168.788C441.655 168.474 441.009 167.943 440.555 167.261C440.1 166.58 439.858 165.78 439.858 164.961C439.858 164.238 439.571 163.544 439.059 163.033C438.548 162.521 437.854 162.234 437.131 162.234C436.407 162.234 435.714 162.521 435.202 163.033C434.691 163.544 434.403 164.238 434.403 164.961C434.401 166.737 434.893 168.479 435.824 169.992C436.755 171.504 438.089 172.728 439.676 173.526C441.263 174.324 443.04 174.665 444.81 174.51C446.579 174.355 448.271 173.711 449.695 172.65C451.12 171.589 452.221 170.152 452.875 168.501C453.53 166.85 453.712 165.049 453.401 163.3C453.091 161.551 452.3 159.923 451.117 158.598C449.934 157.273 448.406 156.304 446.703 155.798V45.8364H455.54C456.263 45.8364 456.957 45.549 457.468 45.0376C457.98 44.5261 458.267 43.8324 458.267 43.1091V25.1636C458.267 24.4403 457.98 23.7466 457.468 23.2352C456.957 22.7237 456.263 22.4364 455.54 22.4364ZM438.194 40.3818L441.958 37.6545L445.722 40.3818H438.194ZM438.194 27.8909H445.722L441.903 30.6182L438.194 27.8909ZM437.431 34.1364L430.64 39.2636L423.849 34.1364L430.64 29.0091L437.431 34.1364ZM419.322 30.6182L415.585 27.8909H423.085L419.322 30.6182ZM414.794 34.0273L408.003 39.1818L401.185 34.0273L408.003 28.9L414.794 34.0273ZM396.658 30.6182L392.812 27.8909H400.34L396.658 30.6182ZM392.131 34.0273L385.34 39.1545L378.549 34.0273L385.34 28.9L392.131 34.0273ZM374.049 30.6182L370.285 27.8909H377.785L374.049 30.6182ZM369.522 34.0273L365.758 36.7546V31.3L369.522 34.0273ZM354.14 14.3909L360.303 8.93637V20.0909L354.14 14.3909ZM354.794 22.4364H345.385L350.076 18.1818L354.794 22.4364ZM350.076 10.8455L344.812 6.07273H355.367L350.076 10.8455ZM346.013 14.5L339.849 20.0909V8.93637L346.013 14.5ZM339.849 27.8909H360.303V40.3818H339.849V27.8909ZM360.303 105.345L354.303 100.273L360.303 95.2V105.345ZM360.303 84.5091L354.303 79.4364L360.303 74.2546V84.5091ZM358.176 89.9636L349.994 96.8091L341.812 89.9636L349.994 83.1182L358.176 89.9636ZM339.849 95.4182L345.849 100.491L339.849 105.564V95.4182ZM339.849 84.7273V74.2546L345.849 79.3273L339.849 84.7273ZM339.849 116.309L345.849 121.382L339.849 126.455V116.309ZM341.949 110.855L350.131 103.982L358.312 110.855L350.131 117.727L341.949 110.855ZM360.303 116.309V126.455L354.303 121.382L360.303 116.309ZM350.076 75.8636L341.894 68.9909L350.076 62.1182L358.258 68.9909L350.076 75.8636ZM339.849 63.6182V53.4727L345.849 58.5455L339.849 63.6182ZM339.849 136.927L345.849 142L339.849 147.073V136.927ZM341.976 131.473L350.158 124.627L358.34 131.473L350.158 138.318L341.976 131.473ZM360.303 136.927V147.073L354.303 142L360.303 136.927ZM360.303 63.6182L354.303 58.5455L360.303 53.4727V63.6182ZM350.076 54.9727L339.849 46.3545V45.8364H360.303V46.3545L350.076 54.9727ZM350.076 145.573L359.294 153.345H340.994L350.076 145.573ZM374.049 37.5455L377.785 40.2727H370.285L374.049 37.5455ZM396.658 37.5455L400.422 40.2727H392.812L396.658 37.5455ZM419.322 37.5455L423.085 40.2727H415.585L419.322 37.5455ZM446.594 34.1091L452.813 29.3636V38.8L446.594 34.1091ZM305.54 27.8909H308.049V40.3818H305.54V27.8909ZM330.303 40.3818V27.8909H334.394V40.3818H330.303Z",
    fill: "#CDD0D9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Block10",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M732.218 224.255C733.032 219.913 730.172 215.732 725.83 214.917L451.613 163.475C447.27 162.66 443.09 165.52 442.275 169.863L430.475 232.766C429.66 237.108 432.52 241.289 436.862 242.103L711.079 293.546C715.422 294.36 719.603 291.5 720.417 287.158L732.218 224.255ZM449.5 172C451.433 172 453 170.433 453 168.5C453 166.567 451.433 165 449.5 165C447.567 165 446 166.567 446 168.5C446 170.433 447.567 172 449.5 172Z",
    fill: "#570177"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M444.802 169.029C445.605 168.871 446.344 168.479 446.925 167.902L452.59 167.991C452.821 167.994 452.963 168.288 452.875 168.501C452.221 170.152 451.12 171.589 449.695 172.65C448.271 173.711 446.579 174.355 444.81 174.51C443.04 174.665 441.263 174.324 439.676 173.526C438.089 172.728 436.755 171.504 435.824 169.992C434.893 168.479 434.401 166.737 434.403 164.961C434.403 164.238 434.691 163.544 435.202 163.033C435.714 162.521 436.407 162.234 437.131 162.234C437.854 162.234 438.548 162.521 439.059 163.033C439.571 163.544 439.858 164.238 439.858 164.961C439.858 165.78 440.1 166.58 440.555 167.261C441.009 167.942 441.655 168.474 442.411 168.788C443.167 169.103 443.999 169.187 444.802 169.029Z",
    fill: "#CDD0D9"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Block02",
    x: 584.796,
    y: 101.198,
    width: 508,
    height: 80,
    rx: 8,
    transform: "rotate(-4.08558 584.796 101.198)",
    fill: "#D64933"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlocks);
export default __webpack_public_path__ + "static/media/Blocks.a34af17749e05365f5a2408cf18f6540.svg";
export { ForwardRef as ReactComponent };